import { HomeHeader } from "./HomeHeader";
import { HomeMainSections } from "./HomeMainSections";
import { useState, useEffect } from "react";

export const HomePage = () => {
    return (
        <div className="bg-dark">
            <HomeHeader />
            {/* <HomeMainSections /> */}
            <div className="container min-vh-100">
                {/* <div>
                    <div className="col p-3 img-fluid d-flex justify-content-center text-center">
                        <img
                            className="mx-2 img-fluid"
                            src="../images/DS-emb2.png"
                            alt="Logo"
                            width="400px"
                        />
                    </div>
                </div> */}
                <HomeMainSections />
            </div>
        </div>
    );
};
